'use strict';

angular.module('mobile-apps')
	.directive('roleLabel',[function() {
		return {
			scope:
			{
				role : '@'
			},
			replace: true,
			templateUrl: 'modules/mobile-apps/views/role-label.client.view.html',
			link: function (scope, elem, attrs) {
			}
		};
	}]);
